<dynamic-form
  [apiName]="apiName"
  [label]="label"
  [group]="formGroup"
  [areaName]="areaName"
  [model]="model"
  [columns]="columns"
  (valueChange)="submitChange($event)"
  [isShowModal]="true"
  [saveLabel]="'ClientApp.FrontOffice.TaxPayerSystem.Sending' | translate"
  (cancelChange)="cancel()"
  (submitChange)="save()">
  <ng-container class="content">
    <ssg-tabset class="tab-container">
      <ssg-tab [tabTitle]="'ClientApp.FrontOffice.TaxPayerSystem.TaxPayerSystem' | translate">
        <kgrid 
          [noAutoFitColumns]="true"
          [hideToolber]="true"
          (valueChange)="submitChange($event)"
          [areaName]="areaName"
          [label]="label"
          [name]="apiName"
          [dataList]="invoiceList"
          [isMulti]="false"
          [isEdit]="false"
          [isDelete]="false"
          pagingSize="5"
          pathPreFix="SALE"
          [columns]="gridColumns">
        </kgrid>
      </ssg-tab>
    </ssg-tabset>
  </ng-container>
</dynamic-form>
